/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/

import customFetchBase from "../lib/redux/customFetchBase.ts"
import {createApi} from "@reduxjs/toolkit/query/react"
import {
    OrderCodeRequest,
    OrderCodeResponse, OrderPaymentMinimal,
    OrderPaymentRequest,
    OrderPaymentResponse, OrderPaymentStatusResponse,
} from "../types/order";

export const orderApi = createApi({
    reducerPath: "orderApi",
    tagTypes: ['OrderData'],
    baseQuery: customFetchBase,
    endpoints: (builder) => ({
        getPaymentStatus: builder.query<OrderPaymentMinimal, string>({
            query(idPayment) {
                return {
                    url: `/payment/${idPayment}`,
                    method: 'GET',
                    credentials: 'include'
                };
            },
            transformResponse: (result: OrderPaymentStatusResponse) =>
                result.data
        }),
        getCode: builder.mutation<OrderCodeResponse, OrderCodeRequest>({
            query({code, request}) {
                return {
                    url: `/code/${code}`,
                    method: 'PATCH',
                    credentials: 'include',
                    body: request
                };
            },
            invalidatesTags: [{type: 'OrderData'}],
        }),
        createPayment: builder.mutation<OrderPaymentResponse, OrderPaymentRequest>({
            query({request}) {
                return {
                    url: `/payment/`,
                    method: 'POST',
                    credentials: 'include',
                    body: request,
                };
            },
            invalidatesTags: [{type: 'OrderData'}],
        }),
    })
})

export const {
    useGetPaymentStatusQuery,
    useCreatePaymentMutation,
    useGetCodeMutation,
} = orderApi
